export const CASES = {
  UPDATE_PMX_PRICES_AND_DATES: "UPDATE_PMX_PRICES_AND_DATES",
  UPDATE_PMX_PRICES_AND_DATES_SEARCH_FORM:
    "UPDATE_PMX_PRICES_AND_DATES_SEARCH_FORM",
  CLEAR_PMX_PRICES_AND_DATES: "CLEAR_PMX_PRICES_AND_DATES",
};
